import type { WidgetId } from '@wix/members-area-app-definitions';

import { SANTA_MEMBERS_APP_DEF_ID } from '../constants/widget';
import {
  type MembersAreaPublicAPI as IMembersAreaPublicAPI,
  type Section,
} from '../types/services';

export class MembersAreaPublicAPI implements IMembersAreaPublicAPI {
  constructor(
    private readonly getPublicAPI: <T>(
      appDefId: string,
    ) => Promise<T | undefined>,
  ) {}

  async getSectionUrl(section: Section) {
    const membersApi = await this.getMembersAreaPublicAPI();
    return membersApi?.getSectionUrl(section) ?? '';
  }

  async getRoutes() {
    const membersApi = await this.getMembersAreaPublicAPI();
    return membersApi?.getRoutes();
  }

  async getSettingsRoutes() {
    const membersApi = await this.getMembersAreaPublicAPI();
    return membersApi?.getSettingsRoutes() ?? [];
  }

  async navigateToSection(widgetId: WidgetId) {
    const membersApi = await this.getMembersAreaPublicAPI();
    return membersApi?.navigateToSection(widgetId);
  }

  private getMembersAreaPublicAPI() {
    return this.getPublicAPI<IMembersAreaPublicAPI>(SANTA_MEMBERS_APP_DEF_ID);
  }
}
